<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>网站配置</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/config/language">网站配置</el-breadcrumb-item>
        <el-breadcrumb-item>语言配置列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>语言配置列表</span>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="100"></el-table-column>
          <el-table-column prop="type" label="位置" width="200"></el-table-column>
          <el-table-column prop="zh" label="中文"></el-table-column>
          <el-table-column prop="en" label="英语"></el-table-column>
          <el-table-column prop="ja" label="日语"></el-table-column>
          <el-table-column prop="ko" label="韩语"></el-table-column>
          <el-table-column label="操作" width="100">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="修改信息" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="名称(中文)" :label-width="formLabelWidth" prop="zh">
          <el-input v-model="ruleForm.zh" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称(英文)" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.en" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称(日文)" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.ja" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称(韩文)" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.ko" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      id: "",
      page: 0,
      count: 0,
      limit: 10,
      dialogFormVisible: false,
      ruleForm: {
        zh: "",
        en: "",
        ja: "",
        ko: "",
      },
      rules: {
        zh: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      search: {
        keys: "",
      },
      formLabelWidth: "120px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/language/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/language/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/language/store";
        if (that.id) {
          formData.id = that.id;
          url = "/language/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>